//
//  KentaroUser.ts
//
//  isana.net,inc. Proprietary and Confidential
//

class KentaroUser {
  readonly REGEX = /ID: (\d+) companyID: (\w+)/;

  readonly orginal: string;
  readonly id: string;
  readonly companyId: string;

  constructor(text: string) {
    const matched = text.match(this.REGEX);
    if (!matched) {
      throw new Error("Invalid text");
    }
    this.orginal = text;
    this.id = matched[1];
    this.companyId = matched[2];
  }
}

export default KentaroUser;
